<app-profile-picture-cropper
    *ngIf="isImageCropperDisplaying"
    [imageChangedEvent]="imageSelectionEvent"
    (blobEventEmitter)="receiveProfilePicture($event)">
</app-profile-picture-cropper>

<div class="md:p-8" style="width: 100%; height: 100%;" *ngIf="user">
    <!--top content begin-->
    <div class="upper-content flex justify-content-between md:w-8 my-3">
        <div class="upper-left">
            <h1 class="font-bold text-gray-700">{{ 'sipo.profile-data' | translate }}</h1>
            <span class="text-gray-500">{{ 'sipo.manage-profile-data' | translate }}</span>
        </div>
        <div class="upper-right relative flex align-items-center justify-content-center">
            <div class="absolute top-0 right-0 overflow-hidden">
                <i class="pi pi-trash cursor-pointer hover:shadow-4 border-circle text-white bg-red-500 font-bold p-2"
                   (click)="profilePictureProperty.userPropertyValue = ''"></i>
            </div>
            <div class="absolute bottom-0 right-0 overflow-hidden">
                <i class="pi pi-pencil cursor-pointer hover:shadow-4 border-circle text-white font-bold p-2"
                   style="background-color: var(--secondary-400);"></i>
                <input type="file" accept="image/*"
                       class="absolute z-5 bottom-0 right-0 cursor-pointer w-full h-full opacity-0"
                       (change)="onFileSelected($event)"/>
            </div>
            <div class="sm:w-5rem md:w-6rem h-6rem border-circle overflow-hidden">
                <img *ngIf="profilePictureProperty && profilePictureProperty.userPropertyValue.length > 0"
                     [src]="profilePictureProperty.userPropertyValue" class="w-full" alt="">
            </div>
            <div
                *ngIf="profilePictureProperty && (profilePictureProperty.userPropertyValue.length === 0 || !profilePictureProperty.userPropertyValue)"
                class="w-5rem h-5rem md:w-6rem md:h-6rem flex align-items-center justify-content-center border-circle shadow-5">
                PP
            </div>
        </div>
    </div>
    <!--top content end-->

    <!--card 1 (name field) begin-->
    <div class="middle-content md:w-8 py-2 my-4 shadow-1">
        <div class="middle-upper flex align-items-center p-4 border-bottom-1 border-200">
            <span class="text-gray-600 font-bold" style="flex-grow: 1;">{{ 'sipo.name' | translate }}</span>
            <span class="text-gray-500" style="flex-grow: 2;">{{ user.firstname }} {{ user.lastname }}</span>
            <div class="text-gray-500 middle-bottom mb-3 flex justify-content-between">
               <!-- <p-button [outlined]="true" [text]="true" (click)="open2Fa()">2Fa login</p-button>-->
            </div>
        </div>
        <div class="middle-mid p-4">
            <div>
                <span class="block pb-1 font-bold">{{ 'sipo.change-name' | translate }}</span>
                <span class="text-gray-500">{{ 'sipo.change-name-info' | translate }}</span>
            </div>
            <div class="my-3 flex justify-content-between">
                <input
                    id="username" type="text" pInputText [(ngModel)]="user.firstname" class="w-6 mr-2"/>
                <input
                    id="userlastname" type="text" pInputText [(ngModel)]="user.lastname" class="w-6 ml-2"/>
            </div>
        </div>
        <div class="middle-bottom px-4 mb-3 flex justify-content-between">
            <p-button [label]="'sipo.cancel' | translate" [outlined]="true"/>
            <p-button [label]="'sipo.save' | translate" [raised]="true" (click)="saveChanges()"/>
        </div>
    </div>
    <!--card 1 (name field) end-->

    <!--card 2 (statistics dashboard) begin-->
    <div class="md:w-8 p-4 my-4 shadow-1 flex justify-content-between">
        <div class="w-12 pr-4 border-gray-300">
            <div class="w-full flex justify-content-between mb-4">
                <div class="w-4">
                    <div class="text-4xl font-bold">{{ totalDocumentAmount }}</div>
                    <div class="text-lg text-gray-400">
                        {{ 'sipo.profile-data-component.total-documents' | translate }}
                    </div>
                </div>
                <div class="w-4">
                    <div class="text-4xl font-bold">{{ finishedDocumentAmount }}</div>
                    <div class="text-lg text-gray-400">
                        {{ 'sipo.profile-data-component.finished-documents' | translate }}
                    </div>
                </div>
                <div class="w-4">
                    <div class="text-4xl font-bold">{{ inProgressDocumentAmount }}</div>
                    <div class="text-lg text-gray-400">
                        {{ 'sipo.profile-data-component.in-progress-documents' | translate }}
                    </div>
                </div>
            </div>
            <div class="w-full flex align-items-center">
                <div class="w-6">
                    <p-chart type="pie" [data]="pieChartData" [options]="pieChartOptions"/>
                </div>
<!--                <div class="w-6 px-1">-->
<!--                    <div class="w-full h-1rem border-round-xl overflow-hidden flex">-->
<!--                        <div class="h-full bg-red-600"></div>-->
<!--                        <div class="h-full bg-blue-600"></div>-->
<!--                    </div>-->
<!--                </div>-->
                <div class="w-6">
                    <p-chart type="bar" [data]="barChartData" [options]="barChartOptions" />
                </div>
            </div>
        </div>
<!--        <div class="w-5 pl-2">
            <div class="font-bold text-3xl text-gray-700 pb-1 mb-1">
                Purchases
            </div>
            <div class="flex align-items-center py-2 font-semibold" *ngFor="let purchase of purchases">
                <div class="w-3">{{ purchase.date }}</div>
                <div class="w-3">{{ purchase.amount }}</div>
                <div class="w-6">{{ purchase.type }}</div>
            </div>
        </div>-->
    </div>
</div>
